import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Toast from 'react-bootstrap/Toast';

 function AutohideToaster({action,message,handleFucntion}) {
  const [show, setShow] = useState(true);

 setInterval(()=>handleFucntion(),7000)

  return (
    <Row>
      <Col xs={6}>
        <Toast onClose={() => setShow(false)} show={show} autohide style={{position: 'fixed', top: 20, right: 20,zIndex:99}}  delay={7000}>
        { action === "s" ? <Toast.Header  style={{background:'green',color:'white'}}>
           
            <strong className="me-auto">Success</strong>
           
          </Toast.Header>:<Toast.Header  style={{background:'red',color:'white'}}>
           
           <strong className="me-auto">Error</strong>
          
         </Toast.Header>}
          <Toast.Body>{message}</Toast.Body>
        </Toast>
      </Col>
     
    </Row>
  );
}

export default AutohideToaster;